import axios from 'axios';
import React from 'react';
import { enqueueSnackbar } from 'notistack';
import { CityModel } from 'src/models/regions/city';
import { API_url } from '../api.setup';

const API_Controller = '/City';

export const CityService = {
  getAllCity: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as CityModel[];
    } catch (error) {
      throw error;
    }
  },

  addCity: async (cityToUpdate: CityModel) => {
    try {
      const reqModel = {
        name: cityToUpdate.name,
        status: cityToUpdate.status,
        stateID: cityToUpdate.state.id
      };

      const response = await axios.post(
        `${API_url}${API_Controller}`,
        reqModel
      );
      enqueueSnackbar(`City ${cityToUpdate.name} Added Successfully`, {
        variant: 'success'
      });
      return response.data as CityModel;
    } catch (error) {
      enqueueSnackbar(`City ${cityToUpdate.name} Added Successfully`, {
        variant: 'error'
      });
      throw error;
    }
  },

  deleteCity: async (CityId) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${CityId}`
      );

      return response.data as CityModel;
    } catch (error) {
      throw error;
    }
  },

  editCity: async (editedData: CityModel) => {
    try {
      const reqModel = {
        id: editedData.id,
        name: editedData.name,
        status: editedData.status,
        stateId: editedData.state.id
      };
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        reqModel
      );
      const updatedCity = {
        ...response.data,
        state: editedData.state
      };
      return updatedCity as CityModel;
    } catch (error) {
      throw error;
    }
  }
};
